import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ERROR_PATH } from 'shared/consts';

export const DefaultRedirect: React.FC = (): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(ERROR_PATH, { replace: true });
  }, [navigate]);

  return null;
};
